import { render } from "./quelifacation.vue?vue&type=template&id=27def3cf&scoped=true"
import script from "./quelifacation.vue?vue&type=script&lang=js"
export * from "./quelifacation.vue?vue&type=script&lang=js"

import "./quelifacation.vue?vue&type=style&index=0&id=27def3cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27def3cf"

export default script